export const plannerOT = 'planner/outbound'

export const subZonePath = 'inventory/subzone'

export const positionPath = 'inventory/position'

export const pathZone = 'inventory/zone'
